import * as types from './notificationTypes';

export const showSuccessMessageAction = data => ({ type: types.SUCCESS, data });
export const showErrorMessageAction = data => ({ type: types.ERROR, data });
